import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { api, setToken } from "../../lib/api";
import { ArrowUpRight } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [err, setErr] = React.useState("");
  const [busy, setBusy] = React.useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      const r = await api.login(email.trim().toLowerCase(), password);
      setToken(r.token);
      nav("/admin");
    } catch (e) {
      setErr(e?.response?.data?.detail || "Ungültige Zugangsdaten");
    } finally { setBusy(false); }
  };

  return (
    <main className="min-h-screen bg-white text-[var(--ink)] flex items-center justify-center p-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="font-mono text-[11px] tracking-[0.2em] uppercase underline mb-10 inline-block">← zurück zur Website</Link>
        <div className="mb-8">
          <div className="brut-tag mb-5">CMS / LOGIN</div>
          <h1 className="brut-h2">Dr. B.-Digitec</h1>
          <p className="brut-body opacity-70 mt-3">Bitte mit Admin-Zugang anmelden.</p>
        </div>
        <form onSubmit={submit} className="border-2 border-[var(--ink)] p-6 brut-shadow space-y-4">
          <div>
            <label className="brut-label">E-Mail</label>
            <input data-testid="login-email" type="email" autoFocus required value={email} onChange={e=>setEmail(e.target.value)} className="brut-input" />
          </div>
          <div>
            <label className="brut-label">Passwort</label>
            <input data-testid="login-password" type="password" required value={password} onChange={e=>setPassword(e.target.value)} className="brut-input" />
          </div>
          {err && <div className="text-sm text-red-600 font-mono uppercase tracking-wider" data-testid="login-error">{err}</div>}
          <button disabled={busy} className="brut-btn w-full justify-center" data-testid="login-submit">
            {busy ? "Anmelden…" : "Anmelden"} <ArrowUpRight size={16} />
          </button>
        </form>
      </div>
    </main>
  );
}
